import React from 'react'
import YarnProjection from '.'

function YarnProjectionReports() {
    return (
        <div>
            <YarnProjection isReportScreen />
        </div>
    )
}

export default YarnProjectionReports